<template>
    <div class="sponsor-package" :class="$mq">
        <div class="icon" :style="{ 'background-image': `url(${icon})` }" />
        <div>
            <base-text type="h4">{{ title }} - {{ cost }}</base-text>
            <base-text type="p">
                <ul>
                    <li v-for="(benefit, index) in benefits" :key="index">
                        {{ benefit.description }}
                    </li>
                </ul>
            </base-text>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'sponsor-package',

        props: {
            title: {
                type: String,
                required: true,
            },

            cost: {
                type: String,
                required: true,
            },

            benefits: {
                type: Array,
                required: true,
            },

            icon: {
                type: Array,
                required: true,
            },
        },
    };
</script>

<style lang="scss" scoped>
    .sponsor-package {
        display: flex;
        align-items: center;

        &:not(:last-of-type) {
            margin-bottom: $standard-space;
        }

        .icon {
            width: 25%;
            height: 250px;
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;
            margin-right: 30px;
        }

        &.tablet,
        &.mobile {
            flex-direction: column;

            .icon {
                margin-right: 0;
            }
        }

        &.mobile {
            .icon {
                width: 50%;
            }
        }
    }
</style>
